import styled from "@emotion/styled";
import { Column } from "@components/Flex";

const Layout = styled(Column)`
  width: 100%;
  max-width: 1440px;
  align-items: center;
`;

export default Layout;
